import React from 'react';
import { cn } from '@/lib/utils';

export const StatusBadge = ({ status, className }) => {
  const statusStyles = {
    ativo: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    inativo: 'bg-slate-100 text-slate-600 border-slate-200',
    disponivel: 'bg-blue-100 text-blue-700 border-blue-200',
    em_uso: 'bg-slate-100 text-slate-700 border-slate-300',
    manutencao: 'bg-orange-100 text-orange-700 border-orange-200',
    aprovado: 'bg-green-100 text-green-700 border-green-200',
    reprovado: 'bg-red-100 text-red-700 border-red-200',
    pendente: 'bg-indigo-100 text-indigo-700 border-indigo-200',
    integra: 'bg-teal-100 text-teal-700 border-teal-200',
    vencido: 'bg-red-100 text-red-700 border-red-200',
    alta: 'bg-red-100 text-red-700 border-red-200',
    media: 'bg-blue-100 text-blue-700 border-blue-200',
  };

  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
        statusStyles[status] || 'bg-gray-100 text-gray-700 border-gray-200',
        className
      )}
    >
      {status}
    </span>
  );
};